exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Y5OnbEWPlcoW7c8BABKDH{display:inline-block}html[dir] ._1Y5OnbEWPlcoW7c8BABKDH{padding:2px}._1sp2__lp1mL_k3p92BjUyQ{display:inline;width:70%}html[dir=ltr] ._1sp2__lp1mL_k3p92BjUyQ{float:left}html[dir=rtl] ._1sp2__lp1mL_k3p92BjUyQ{float:right}._2V618j3KYWlMySjRbe0RHX{display:inline}html[dir=ltr] ._2V618j3KYWlMySjRbe0RHX{float:right}html[dir=rtl] ._2V618j3KYWlMySjRbe0RHX{float:left}html[dir] ._3AfIC4IAcGmzHYMsjfDYpe{padding-top:50px}._2KHFvvLVMYjpcPavoylVza{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
exports.locals = {
	"spinner": "_1Y5OnbEWPlcoW7c8BABKDH",
	"domain_text_container": "_1sp2__lp1mL_k3p92BjUyQ",
	"domain_btn_container": "_2V618j3KYWlMySjRbe0RHX",
	"messagebar": "_3AfIC4IAcGmzHYMsjfDYpe",
	"waitingSpin": "_2KHFvvLVMYjpcPavoylVza"
};